export function formatTime(dateStr) {
  if (!dateStr) return "TBD"
  const d = new Date(dateStr)
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
}

export function formatDate(dateStr) {
  if (!dateStr) return ""
  const d = new Date(dateStr)
  return d.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" })
}

export function formatDateShort(dateStr) {
  if (!dateStr) return ""
  const d = new Date(dateStr)
  return d.toLocaleDateString([], { month: "short", day: "2-digit", year: "numeric" })
}

export function formatDuration(seconds) {
  if (seconds == null) return "—"
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return m > 0 ? `${m}m ${s}s` : `${s}s`
}

export function formatFileSize(bytes) {
  if (!bytes) return ""
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function formatTimeOnly(dateStr) {
  if (!dateStr) return "—"
  return new Date(dateStr).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" })
}

// Parses an RRULE into a human-readable pair: a static `prefix`
// (e.g. "Weekly on ") and an optional `days` list ("Tue, Thu") kept separate
// so callers can style the day list differently. For non-weekly frequencies
// or weekly rules without BYDAY, `days` is null and `prefix` carries the
// whole description.
export function describeRecurrence(rrule) {
  if (!rrule) return { prefix: null, days: null }
  const parts = Object.fromEntries(rrule.split(";").map(p => p.split("=")))
  const freq = parts.FREQ?.toLowerCase()
  const interval = parseInt(parts.INTERVAL || "1", 10)
  const dayMap = { MO: "Mon", TU: "Tue", WE: "Wed", TH: "Thu", FR: "Fri", SA: "Sat", SU: "Sun" }

  if (freq === "daily") {
    return { prefix: interval === 1 ? "Daily" : `Every ${interval} days`, days: null }
  }
  if (freq === "weekly") {
    const base = interval === 1 ? "Weekly" : `Every ${interval} weeks`
    if (parts.BYDAY) {
      const days = parts.BYDAY.split(",").map(d => dayMap[d] || d).join(", ")
      return { prefix: `${base} on `, days }
    }
    return { prefix: base, days: null }
  }
  if (freq === "monthly") {
    return { prefix: interval === 1 ? "Monthly" : `Every ${interval} months`, days: null }
  }
  return { prefix: "Recurring", days: null }
}

export function describeRecurrenceText(rrule) {
  const { prefix, days } = describeRecurrence(rrule)
  if (!prefix) return null
  return days ? `${prefix}${days}` : prefix
}

export function recurrenceEndDate(rrule) {
  if (!rrule) return null
  const parts = Object.fromEntries(rrule.split(";").map(p => p.split("=")))
  if (parts.UNTIL) {
    const s = parts.UNTIL
    const d = new Date(`${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`)
    return isNaN(d) ? null : d.toISOString()
  }
  return null
}
